export default {
  physical_people: [],
  physical_person: null,
  pagination: {}
}
